import { useAtomValue } from 'jotai';

import { useSwingAnalyses } from '@queries';
import { activitySwingsAtom } from '@store';
import { Box, colors, Heading3, Spinner, u, WarningIcon } from '@ui';

import { TableModuleGrid } from './TableModuleGrid';
import * as css from './TablePresenter.css';
import { useTableParameters } from './useTableParameters';

type TablePresenterProps = {
    nodeId: string;
};

export const TablePresenter = ({ nodeId }: TablePresenterProps) => {
    const swings = useAtomValue(activitySwingsAtom);
    const { isLoading: isLoadingAnalysis } = useSwingAnalyses(swings?.map((swing) => swing.uuid) ?? []);
    const tableParameters = useTableParameters(nodeId);
    if (isLoadingAnalysis) {
        return (
            <Box
                width="100%"
                height="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                className={css.minHeight}
            >
                <Spinner size="l" />
            </Box>
        );
    }

    if (tableParameters.length === 0) {
        return (
            <Box display="flex" justifyContent="center" width="100%">
                <Box display="flex" justifyContent="center" alignItems="center" className={css.minusMargin}>
                    <WarningIcon size={u(8)} color={colors.bluegray[200]} />
                    <Heading3 paddingInlineStart={u(2)}>
                        {'Please select parameters from the settings button above'}
                    </Heading3>
                </Box>
            </Box>
        );
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            position="relative"
            className={css.tableRoot}
            pt={u(2)}
            height="100%"
        >
            <TableModuleGrid interactive nodeId={nodeId} />
        </Box>
    );
};
